import React from 'react';

const SearchInfo = ({ isVisible }) => {
  return (
    <div
      className={`absolute w-screen h-[calc(100vh-98px)] bg-[#F6F3EA] z-[100] top-[98px] left-0 flex flex-col justify-center items-center pt-8 px-4 pb-8 transition-all duration-300 ease-in-out ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <div className="px-4 flex flex-col">
        <div className="flex flex-col justify-between items-center p-4">
          <p className="text-black text-center font-primary text-[20px] font-normal leading-[150%] uppercase">
            Your Journey Begins Here.
          </p>
          <p className="text-black text-center font-primary text-[14px] font-normal leading-[150%]">
            Discover handpicked spots and events. Start by typing what you're looking for!
          </p>
        </div>
      </div>
    </div>
  );
};

export default SearchInfo;
